import Toast from 'common/components/Toast'
import { action, thunk } from 'easy-peasy'
import objectToCamelCase from 'lib/transform/object-to-camel-case'
import IRecommendationModel from 'services/Marketplace/models/RecommendationsModel/interface'

const RecommendationModel: IRecommendationModel = {
  isLoading: false,
  isError: false,
  errorMessage: '',
  data: null,

  setIsLoading: action((state, payload) => {
    state.isLoading = payload
  }),

  setIsError: action((state, payload) => {
    state.isError = payload
  }),

  setErrorMessage: action((state, payload) => {
    state.errorMessage = payload
  }),

  setData: action((state, payload) => {
    state.data = payload
  }),

  getRecommendations: thunk(async (actions, _, { injections }) => {
    try {
      actions.setIsLoading(true)
      actions.setIsError(false)

      const { apiClient } = injections
      const res = await apiClient({
        url: '/marketplace/v1/recommendations',
        method: 'GET',
      })

      if (res.status === 200) {
        const resData = objectToCamelCase(res.data.data)
        actions.setData(resData)
      }
    } catch (err) {
      actions.setIsError(true)
      actions.setErrorMessage(
        err?.response?.data?.message ?? err.message,
      )
      Toast(err?.response?.data?.message ?? err.message, {
        type: 'error',
        theme: 'colored',
        position: 'top-center',
        toastId: 'error-get-recommendations',
      })
    } finally {
      actions.setIsLoading(false)
    }
  }),
}

export default RecommendationModel
